import {
  sanitizeRichHtml,
  sanitizeLegacyInlineHtml,
} from '../../../utils/userContentSanitize';

/**
 * Renders a song description as safe HTML, with @handle mentions and bare
 * URLs turned into anchor tags.
 *
 * Two paths:
 *   - Rich text (TipTap HTML): starts with `<`, handed straight to the
 *     strict rich-text sanitizer.
 *   - Legacy plain text: linkify @handles (restricted to `mentionedHandles`
 *     if provided) and bare URLs, then run through the legacy inline
 *     sanitizer.
 *
 * Returning a string keeps callers free to hand the result to
 * `dangerouslySetInnerHTML`; sanitization is always applied.
 */
export const renderDescriptionWithLinks = (text, mentionedHandles) => {
  if (!text) return '';

  if (text.startsWith('<')) {
    return sanitizeRichHtml(text);
  }

  const confirmedSet = mentionedHandles
    ? new Set(mentionedHandles.map((h) => h.toLowerCase()))
    : null;

  const withMentions = text.replace(
    /(^|[\s\n])@([a-z0-9_]+)/gi,
    (match, prefix, handle) => {
      if (confirmedSet && !confirmedSet.has(handle.toLowerCase())) return match;
      return `${prefix}<a href="/user/@${handle}" data-mention-handle="${handle}">@${handle}</a>`;
    }
  );

  const rawHtml = withMentions.replace(/(https?:\/\/[^\s]+)/g, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return sanitizeLegacyInlineHtml(rawHtml);
};
